export class OffCanvasMenu {
    constructor() {
        let offCanvasWrapper = document.querySelector('.c-offcanvas-wrapper');

        if (offCanvasWrapper) {
            let activeThirdLevelMenu = document.querySelector('.c-offcanvas-menu-third-level.active');
            //const bodyScrollLock = require('body-scroll-lock');
            //const disableBodyScroll = bodyScrollLock.disableBodyScroll;
            //const enableBodyScroll = bodyScrollLock.enableBodyScroll;

            // open off-canvas menu
            document.querySelector('.c-header-burgermenu').addEventListener('click', () => {
                offCanvasWrapper.classList.toggle('active');
                //disableBodyScroll(document.querySelector('.c-offcanvas'));
            });

            // close off-canvas menu
            document.querySelectorAll('.c-offcanvas-header-close, .c-offcanvas-overlay, .c-offcanvas-menu-close-third-level').forEach((item) => {
                item.addEventListener('click', () => {
                    offCanvasWrapper.classList.remove('active');
                    //enableBodyScroll(document.querySelector('.c-offcanvas'));
                });
            });

            // open third-level-menu
            document.querySelectorAll('.c-offcanvas-menu-second-level-expand').forEach((item) => {
                item.addEventListener('click', (e) => {
                    let target = item.dataset.target;
                    document.getElementById(target).classList.add('active');
                    document.getElementById(target).parentNode.scrollTop = 0;
                    setThirdLevelMenuHeight(document.getElementById(target));
                });
            });

            // close third-level-menu
            document.querySelectorAll('.c-offcanvas-back').forEach((item) => {
                item.addEventListener('click', () => {
                    $(item).closest('.c-offcanvas-menu-third-level').removeClass('active');
                });
            });

            if (activeThirdLevelMenu) {
                setThirdLevelMenuHeight(activeThirdLevelMenu);
            }

            /**
             * Set scroll height to avoid overlapping elements on scroll
             * @param thirdLevelMenu
             */
            function setThirdLevelMenuHeight(thirdLevelMenu) {
                thirdLevelMenu.style.height = document.querySelector('.c-offcanvas').scrollHeight + 'px';
            }
        }
    }

}
